import { render } from "./HomeNew.vue?vue&type=template&id=4423eff8&scoped=true"
import script from "./HomeNew.vue?vue&type=script&lang=js"
export * from "./HomeNew.vue?vue&type=script&lang=js"

import "./HomeNew.vue?vue&type=style&index=0&id=4423eff8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4423eff8"]])

export default __exports__